"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.81",
    y: "5.17",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.57,0H0V1.49H21.82V13.94H0v1.9H21.82v4H0v1.49H5.22a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0h2a.75.75,0,0,0,.75-.74V.75A.75.75,0,0,0,22.57,0ZM8.92,22.5a2.41,2.41,0,0,1-2.07-1.18H11A2.38,2.38,0,0,1,8.92,22.5Zm7.91,0a2.39,2.39,0,0,1-2.06-1.18H18.9A2.41,2.41,0,0,1,16.83,22.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.36,5.17H0v6.46H13.36a.5.5,0,0,0,.5-.5V5.67A.5.5,0,0,0,13.36,5.17Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "34.85",
    y: "5.17",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.46.75V20.58a.75.75,0,0,0,.75.74h2a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0h5.21V19.83H33v-4H54.77v-1.9H33V1.49H54.77V0H32.21A.75.75,0,0,0,31.46.75ZM43.8,21.32h4.13a2.41,2.41,0,0,1-2.07,1.18A2.38,2.38,0,0,1,43.8,21.32Zm-7.92,0H40a2.4,2.4,0,0,1-4.13,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.42,5.17H54.77v6.46H41.42a.5.5,0,0,1-.5-.5V5.67A.5.5,0,0,1,41.42,5.17Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.64,21.32H17.26a.75.75,0,1,1,0-1.49h9.38a.75.75,0,1,1,0,1.49Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.52,21.32H28.14a.75.75,0,1,1,0-1.49h9.38a.75.75,0,1,1,0,1.49Z"
  }));
};

exports["default"] = _default;